import React from 'react';

/**
 * Overlay de sucesso ao vincular usuário ao Canny (animação + mensagem).
 * A animação cannySuccessPulse está definida em App.css.
 */
function CannySuccessOverlay({ show }) {
  if (!show) return null;
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(255,255,255,0.92)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '12px',
        zIndex: 10
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            backgroundColor: '#10b981',
            margin: '0 auto 12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: 'cannySuccessPulse 0.6s ease-out'
          }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <span style={{ fontSize: '15px', fontWeight: 600, color: '#059669' }}>Vinculado ao Canny</span>
      </div>
    </div>
  );
}

export default CannySuccessOverlay;
